import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const NavGridContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr); /* Three columns */
	gap: 20px;
	margin: 0 20px 20px 20px;
`;

export const Breadcrumbs = styled.div`
	display: flex;
	align-items: center;
	font-weight: 500;
	margin-top: 10px;
	margin-left: 20px;
	font-size: 12px;
	letter-spacing: 0.3px;
	color: ${colors.grey6};
	padding-bottom: 20px;
	span {
		cursor: pointer;
		font-size: 12px;
	}

	span:hover {
		cursor: pointer;
		color: ${colors.grey9};
	}
`;

export const Section = styled.section`
	margin-left: 80px;
	margin-right: 80px;
	margin-bottom: 10px;
`;

export const Title = styled.h1`
	font-size: 30px;
	color: black;
	background-color: lightgrey;
	text-transform: uppercase;
	font-weight: 300;
	text-align: center;
	margin-bottom: 15px;
`;

export const Table = styled.table`
	width: 100%;
	table-layout: fixed;
`;

export const TblHeader = styled.div`
	background-color: rgba(255, 255, 255, 0.3);
	border: 1px solid black;
`;

export const TblContent = styled.div`
	height: auto;
	overflow-x: auto;
	margin-top: 0px;
	border: 1px solid black;
`;

export const Th = styled.th`
	padding: 2.5px 1.25px;
	text-align: left;
	font-weight: 500;
	font-size: 12px;
	color: black;
	text-transform: uppercase;
`;

export const Td = styled.td`
	padding: 2.5px;
	text-align: left;
	vertical-align: middle;
	font-weight: 300;
	font-size: 12px;
	color: black;
	border-bottom: solid 1px lightgrey;
`;
